import React from 'react';

import faqUrl from '@/utils/urls/faqUrl';

import type { SocialProfileNetworkType } from '@/types/socialProfileType';

import { POST, STORY } from '@/lib/posts/postTypes';
import {
    FACEBOOK,
    INSTAGRAM,
    LINKEDIN,
    PINTEREST,
    TIKTOK_BUSINESS,
    TWITTER,
    YOUTUBE
} from '@/lib/socialProfile';
import { url_faq_estimated_followers } from '@/lib/urls/faqUrls';

import LinkBase from '@/components/base/LinkBase';
import { Trans } from '@/components/tools/translation';

type MediaViewerIncompleteStatsBannerProps = {
    network: SocialProfileNetworkType;
    type: typeof STORY | typeof POST;
};

const bannerTranslation = {
    [INSTAGRAM]: {
        [STORY]: 'analytics:story_lack_data_media_viewer',
        [POST]: 'analytics:lack_data_media_viewer'
    },
    [FACEBOOK]: 'analytics:lack_data_media_viewer',
    [LINKEDIN]: 'analytics:linkedin_lack_data_media_viewer',
    [PINTEREST]: 'analytics:pinterest_lack_data_media_viewer',
    [TWITTER]: 'analytics:twitter_lack_data_media_viewer',
    [TIKTOK_BUSINESS]: 'analytics:tiktok_lack_data_media_viewer',
    [YOUTUBE]: 'analytics:youtube_lack_data_media_viewer'
} as const;

const MediaViewerIncompleteStatsBanner = ({
    network,
    type
}: MediaViewerIncompleteStatsBannerProps): React.ReactElement => {
    return (
        <Trans
            i18nKey={
                typeof bannerTranslation[network] === 'object'
                    ? bannerTranslation[network][type]
                    : bannerTranslation[network]
            }
            components={{
                tag0: (
                    <LinkBase
                        key="learn_more"
                        className="underline"
                        target="_blank"
                        href={faqUrl(url_faq_estimated_followers)}
                        rel="help noopener noreferrer"
                    />
                )
            }}
        />
    );
};

export default MediaViewerIncompleteStatsBanner;
